package com.wintermar.inspection.feature.data.remote.mapper.inspection

import com.wintermar.inspection.core.ui.component.image.util.FileModel
import com.wintermar.inspection.graphql.GenerateInspectionReportPdfQuery

fun GenerateInspectionReportPdfQuery.GenerateInspectionReportPdf.toFileModel(): FileModel {
    return FileModel(
        path = this.url,
        name = this.fileName,
        originalName = this.fileName
    )
}
